module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_010.png
// module id = 955
// module chunks = 0